import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';
import { TagComponent } from '@fcom/ui-components/components/tag/tag.component';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { DirectiveModule } from '@fcom/common/directives/directive.module';

import { ItineraryTimelineComponent } from './itinerary-timeline.component';
import { ItineraryTimelineFlightComponent } from './flight/itinerary-timeline-flight.component';
import { ItineraryTimelineLayoverComponent } from './layover/itinerary-timeline-layover.component';
import { ItineraryTimelineLegEndpointComponent } from './leg-endpoint/leg-endpoint.component';
import { ItineraryTimelineLegTechnicalStopsComponent } from './leg-technical-stops/leg-technical-stops.component';
import { ItineraryTimelineBoundHeaderComponent } from './bound-header/itinerary-timeline-bound-header.component';

const COMPONENTS = [
  ItineraryTimelineComponent,
  ItineraryTimelineFlightComponent,
  ItineraryTimelineLayoverComponent,
  ItineraryTimelineLegEndpointComponent,
  ItineraryTimelineLegTechnicalStopsComponent,
  ItineraryTimelineBoundHeaderComponent,
];

/**
 * `fin-itinerary-timeline` and its sub-components, kept cms-free so `cms` can use them (via
 * `TimetableScheduleModule`) without a cycle. Re-exported by `CommonBookingComponentsModule`,
 * so existing consumers are unaffected.
 */
@NgModule({
  imports: [
    CommonModule,
    IconComponent,
    NotificationComponent,
    TagComponent,
    UiTranslateModule,
    PipesModule,
    DirectiveModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class ItineraryTimelineModule {}
